// eslint-disable-next-line no-restricted-imports -- navigation must not import the businessObjects barrel
import type { ParentScopedChildQuery } from "~/features/businessObjects/utils/parentScopedChildQuery";

import type { RecordHomeCandidate } from "./resolveRecordHome";

/** Parent lookup for record home: from the opened row up to its root record. */
export const recordHomeParentScope = (
  home: RecordHomeCandidate,
  childSchema: string,
  childVersion: string,
  childPk: string,
): ParentScopedChildQuery => ({
  parentResource: childSchema,
  parentVersion: childVersion,
  parentPk: childPk,
  relationship: home.root.schema,
  relationshipVersion: home.root.version,
  childResource: home.root.schema,
  childVersion: home.root.version,
  path: home.parentWalk,
});
